export type BlacklistType = 'channel' | 'loyalty';

export enum Blacklist {
  CHANNEL = 'channel',
  LOYALTY = 'loyalty',
}

export interface BlacklistContainerContextProps {
  showDialog: BlacklistType | null;
  setShowDialog: (showDialog: BlacklistType | null) => void;
}
